/* lua.js generated code 0.3.0 */

// var [MarkPanel, MarkPanelEvent] = unpack(require("clover/panel/MarkPanel"))
var {NewMarkPanel, NewMarkPanelEvent} = require("clover/panel/component/markpanel/NewMarkPanel")
var MarkPriseLogic = require("clover/panelBusLogic/MarkPriseLogic")
var MarkPriseWxChestLogic = require("clover/panelBusLogic/MarkPriseWxChestLogic")
var [MarkPriseButton, MarkPriseButtonEvent] = unpack(require("clover/scene/component/homescene/MarkPriseButton"))
var [MarkPriseWxChestButton, MarkPriseWxChestButtonEvent] = unpack(require("clover/scene/component/homescene/MarkPriseWxChestButton"))
var {RemarkPanel, RemarkPanelEvent} = require("clover/panel/component/markpanel/RemarkPanel")
var MarkLogic = xClass("MarkLogic")
var instance = null
MarkLogic.isCurRunning = function () {
    var self = this
    return instance != null
}
MarkLogic.getUnlockLevel = function () {
    var self = this
    return 2
}
MarkLogic.prototype.ctor = function (cilentFailWhileGettingInfo) {
    var self = this
    self.isBusy = false
    self.waitingAnim = false
    self.priseButton = null
    instance = self
    self.cilentFailWhileGettingInfo = cilentFailWhileGettingInfo
}
MarkLogic.prototype.start = function (finishCallback) {
    var self = this
    function onFinish() {
        instance = null
        if (finishCallback) {
            finishCallback()
        }
    }
    function onGetInfo(oldMarkInfo, lockTable) {
        if (oldMarkInfo) {
            self.showPanel(oldMarkInfo, self.getFullInfo(), onFinish, lockTable)
        } else {
            self.showPanel(self.getFullInfo(), null, onFinish, lockTable)
        }
        // var HomeScene = require("clover/scene/HomeScene")
        // HomeScene.getInstance().btnLayer.createMarkBtn()
    }
    function onFail() {
        if (onFinish) {
            onFinish()
        }
    }
    self.getMarkInfo(onGetInfo, onFail)
}
MarkLogic.prototype.showPanel = function (buildUIInfo, animInfo, finishCallback, lockTable) {
    var self = this

    //  老签到设置
    function callback(panel) {
        self.waitingAnim = true
        panel.on(MarkPanelEvent.Close, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            evt.target.onClose()
            var button
            if (META.platform == XcloverPlatform.wechatgame || __DEBUG) {
                button = MarkPriseWxChestLogic.prototype.createButton()
            } else {
                button = MarkPriseLogic.prototype.createButton()
            }
            if (button) {
                button.setVisible(true)
            }
            if (finishCallback) {
                finishCallback()
            }
        })
        panel.on(MarkPanelEvent.Mark, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            self.mark(evt.target)
        })
        panel.on(MarkPanelEvent.AdMark, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            if (META.platform == XcloverPlatform.qq ||
                META.platform == XcloverPlatform.weixin){
                //NOTE:腾讯视频没有视频的时候 不会有返回值 所以先不设置busy
                self.isBusy = false
            }
            DCAssist.dc4AdClick("mark", "mark_ad_btn_click", {"ad_src": "mark_panel", "type": "old"});
            self.adMark(evt.target)
        })
        panel.on(MarkPanelEvent.Remark, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            self.remark(evt.target)
        })
        panel.on(MarkPanelEvent.CheckPrise, function (evt) {
            self.checkAndPopPrisePanel(panel)
        })
        /*panel.on(MarkPanelEvent.CheckWxChest, function (evt) {
            if (self.isRemark) {
                return
            }
            self.checkAndPopWxChestPanel(panel)
        })*/
        panel.popup(true, false, function () {
            self.waitingAnim = false
            if (animInfo) {
                var meta = MetaManager.getInstance().getMarkByNum(animInfo.markNum)
                if (meta.goodsId !== 0) {
                    self.popMarkPrise(meta.goodsId, panel)
                }
            }
        }, lockTable)

        if (META.platform == XcloverPlatform.wechatgame || __DEBUG) {
            var button = MarkPriseWxChestLogic.prototype.createButton()
            if (button) {
                button.setVisible(false)
                self.priseButton = MarkPriseWxChestButton.create(button.getEndTime(), button.getClicked())
                self.priseButton.setPosition(cc.p(button.getPosition()))
                self.priseButton.on(MarkPriseWxChestButtonEvent.TimeUp, function () {
                    self.priseButton.removeFromParent(true)
                })
                panel.getParent().addChild(self.priseButton)
                MarkPriseWxChestLogic.prototype.delegateButton(self.priseButton)
            }
        } else {
            var button = MarkPriseLogic.prototype.createButton()
            if (button) {
                button.setVisible(false)
                self.priseButton = MarkPriseButton.create(button.getEndTime())
                self.priseButton.setPosition(cc.p(button.getPosition()))
                self.priseButton.on(MarkPriseButtonEvent.TimeUp, function () {
                    self.priseButton.removeFromParent(true)
                })
                panel.getParent().addChild(self.priseButton)
                MarkPriseLogic.prototype.delegateButton(self.priseButton)
            }
        }
    }

    //  新签到设置
    function newMarkcallback(panel) {
        self.waitingAnim = true
        panel.on(NewMarkPanelEvent.Close, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            evt.target.onClose()
            if (finishCallback) {
                finishCallback()
            }
        })
        panel.on(NewMarkPanelEvent.Mark, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            self.mark(evt.target)
        })
        panel.on(NewMarkPanelEvent.AdMark, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            DCAssist.dc4AdClick("mark", "mark_ad_btn_click", {"ad_src": "mark_panel", "type": "new"});
            self.adMark(null,evt.ttUseDiamond,evt.ad_session)
        })
        panel.on(NewMarkPanelEvent.Remark, function (evt) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            self.newRemark(evt.day, evt.isVideoRemark)
        })
        panel.on(NewMarkPanelEvent.ClickRemark, function (event) {
            if (self.waitingAnim || self.isBusy) {
                return
            }
            self.isBusy = true
            panel.remarkPanel = RemarkPanel.create(event.markInfo)
            //  点击看广告补签按钮事件
            panel.remarkPanel.on(RemarkPanelEvent.AdRemark, function(evt) {
                panel.dispatchEvent(table([1, "name", NewMarkPanelEvent.Remark], [1, "day", evt.day], [1, "isVideoRemark", evt.isVideoRemark]))
            })
            //  点击风车币补签按钮事件
            panel.remarkPanel.on(RemarkPanelEvent.CoinRemark, function(evt) {
                panel.dispatchEvent(table([1, "name", NewMarkPanelEvent.Remark], [1, "day", evt.day], [1, "isVideoRemark", evt.isVideoRemark]))
            })
            //  关闭事件
            panel.remarkPanel.on(RemarkPanelEvent.Close, function() {
                panel.remarkPanel = null
            })
            panel.remarkPanel.popup(true, false, function() {
                self.isBusy = false
            })
        })
        // panel.on(MarkPanelEvent.CheckPrise, function (evt) {
        //     self.checkAndPopPrisePanel(panel)
        // })
        /*panel.on(MarkPanelEvent.CheckWxChest, function (evt) {
            if (self.isRemark) {
                return
            }
            self.checkAndPopWxChestPanel(panel)
        })*/
        panel.popup(true, false, function (canMark) {
            self.waitingAnim = false
            if (animInfo) {
                var meta = MetaManager.getInstance().getMarkByNum(animInfo.markNum)
                if (meta.goodsId !== 0) {
                    self.popMarkPrise(meta.goodsId, panel)
                }
            }
        }, lockTable)
        self.markPanel = panel
    }
    if (UserMark.getInstance().isNewMark()) {
        NewMarkPanel.asyncCreate(buildUIInfo, animInfo, newMarkcallback, finishCallback)
    } else {
        // MarkPanel.asyncCreate(buildUIInfo, animInfo, callback, finishCallback)
    }
}
// 根据需求 获取签到信息并自动签到的流程分为以下几步：（旧版签到）
// 1、以当前本地数据判断当前是否可以签到。如可以签到，则在发送获取信息请求的同时发送签到请求（记为签到1）。
// 2、获取信息成功返回的时候，如果本地判断可以签到，则记录新返回的信息信息（记为原始信息）。
// 3、如果获取信息成功后根据新返回的签到信息判断可以签到，且之前本地判断不能签到，则重新发送签到请求（记为签到2）。
// 4、获取信息的返回时，之前本地判断不可签到，且新信息也不可签到，则流程成功结束。
// 5、获取信息失败则流程失败结束。
// 6、当签到1返回时，如果成功则流程成功结束。
// 7、签到1返回失败，判断是否存在原始信息（第2步写入），有则表示线上数据不可签到，流程成功结束，否则流程失败结束。
// 8、签到2返回成功/失败，流程成功/失败结束。
/**
 * 新版签到流程：
 * 1.先获取当前玩家的签到版本信息，如果为旧版则沿用旧版签到流程，否则使用新签到流程。
 * 2.由于获取签到版本信息的同时也会受到新版签到信息，因此使用新信息判断当前是否可以签到，如果可签则发送签到请求。
 * 3.如果签到请求成功，则播放签到动画和奖励面板，否则流程失败结束。
 */
MarkLogic.prototype.getMarkInfo = function (finishCallback, failCallback) {
    var self = this
    var [markInfo, canMark] = [null, UserMark.getInstance().canMark()]
    var [responsed, secMarked] = [false, true]
    function onMark(succeed, data) {
        if (succeed) {
            if (responsed && secMarked) {
                return
            }
            if (!responsed) {
                responsed = true
            } else {
                secMarked = true
            }
            var [coin, cash] = [0, 0]
            data.rewards = data.rewards || table()
            for (let i = 1, v = data.rewards[1]; v; i++ , v = data.rewards[i]) {
                if (v.itemId === GamePropIds.kCoin) {
                    coin = coin + v.num
                } else if (v.itemId === GamePropIds.kCash) {
                    cash = cash + v.num
                }
            }
            var HomeScene = require("clover/scene/HomeScene")
            var infoBanner = HomeScene.getInstance().infoBanner
            infoBanner.lockCoin(coin)
            infoBanner.lockCash(cash)
            if (finishCallback) {
                finishCallback(markInfo, table([1, "coin", coin], [1, "cash", cash]))
            }
        } else if (data && !self.cilentFailWhileGettingInfo) {
            Toast.make(getText("error.tip." + tostring(data)), null, function () {
                if (failCallback) {
                    failCallback()
                }
            })
        } else if (failCallback) {
            failCallback()
        }
    }
    function onGetInfo(succeed, errCode) {
        if (succeed) {
            markInfo = self.getFullInfo()
            if (finishCallback) {
                finishCallback()
            }
        } else if (errCode && !self.cilentFailWhileGettingInfo) {
            Toast.make(getText("error.tip." + tostring(errCode)), null, function () {
                if (failCallback) {
                    failCallback()
                }
            })
        } else if (failCallback) {
            failCallback()
        }
    }
    // ConnectionManager:syncBlock()
    self.getMarkInfoStepGetInfo(onGetInfo)
}
MarkLogic.prototype.getMarkInfoStepGetInfo = function (finishCallback) {
    var self = this
    function onSuccess() {
        if (finishCallback) {
            finishCallback(true)
        }
    }
    function onFail(evt) {
        if (finishCallback) {
            finishCallback(false, evt.data)
        }
    }
    function onCancel() {
        if (finishCallback) {
            finishCallback(false)
        }
    }
    UserMark.getInstance().updateMarkInfo(true, onSuccess, onFail, onCancel)
}
MarkLogic.prototype.getMarkInfoStepMark = function (finishCallback) {
    var self = this
    function onSuccess(evt) {
        if (finishCallback) {
            finishCallback(true, evt.data)
        }
    }
    function onFail(evt) {
        if (finishCallback) {
            finishCallback(false, evt.data)
        }
    }
    function onCancel() {
        if (finishCallback) {
            finishCallback(false)
        }
    }
    UserMark.getInstance().mark(onSuccess, onFail, onCancel)
}
MarkLogic.prototype.checkAndPopPrisePanel = function (panel) {
    var self = this
    var info = self.getFullInfo()
    var meta = MetaManager.getInstance().getMarkByNum(info.markNum)
    if (meta.goodsId !== 0) {
        self.popMarkPrise(meta.goodsId, panel)
    } else {
        //self.isBusy = false
    }
}

MarkLogic.prototype.getMarkPriseWxChestInfo = function (onSuccess, onFail, onCancel) {
    let self = this
}


MarkLogic.prototype.mark = function (panel) {
    var self = this
    function onSuccess(evt) {
        var info = self.getFullInfo()
        // info.lastMarkRewards = table([0,evt.data.rewards])
        info.lastMarkRewards = evt.data.rewards
        var [coin, cash] = [0, 0]
        evt.data.rewards = evt.data.rewards || table()
        for (let i = 1, v = evt.data.rewards[1]; v; i++ , v = evt.data.rewards[i]) {
            if (v.itemId === GamePropIds.kCoin) {
                coin = coin + v.num
            } else if (v.itemId === GamePropIds.kCash) {
                cash = cash + v.num
            }
        }
        var HomeScene = require("clover/scene/HomeScene")
        var infoBanner = HomeScene.getInstance().infoBanner
        
        //  新签到要弹出界面
        if (UserMark.getInstance().isNewMark()) {
            //  弹出领奖界面
            var config = {}
            config.markReward = evt.data.rewards
            config.todayAdReward = 1
            config.adReward = info.markRef.mark_reward_ad[UserMark.getInstance().getDayPreContinuous()]
            if (evt.data.sevenDaysRewards && $len(evt.data.sevenDaysRewards) > 0) {
                //  七天签到奖励
                config.sevenDaysRewards = evt.data.sevenDaysRewards
            }
            panel.todayMarkRewardAnim = true
            var closeCallback = function() {
                self.isBusy = false
                //panel.dispatchEvent(table([1, "name", NewMarkPanelEvent.Close]))
            }
            panel.onNormalReward()
            panel.refreshWithAnim(info, closeCallback)
        } else {
            infoBanner.lockCoin(coin)
            infoBanner.lockCash(cash)
            //  老版签到直接刷新界面
            panel.refresh(info, 1, function () {
                var meta = MetaManager.getInstance().getMarkByNum(info.markNum)
                if (meta.goodsId !== 0) {
                    //self:popMarkPrise(meta.goodsId, panel)
                }
                self.isBusy = false
            }, table([1, "coin", coin], [1, "cash", cash]))
        }
    }
    function onFail(evt) {
        self.isBusy = false
        Toast.make(getText("error.tip." + tostring(evt.data)))
    }
    function onCancel() {
        self.isBusy = false
    }

    UserMark.getInstance().mark(onSuccess, onFail, onCancel)
}
MarkLogic.prototype.adMark = function (panel,ttUseDiamond, ad_session) {
    var self = this
    
    function onSuccess(evt) {
        var info = self.getFullInfo()

        //  新签到要弹出界面
        if (UserMark.getInstance().isNewMark()) {
            var info = self.getFullInfo()
            info.lastMarkRewards = evt.data.rewards
            //  播放动画
            var callback = function () {
                self.isBusy = false
                //self.markPanel.dispatchEvent(table([1, "name", NewMarkPanelEvent.Close]))
            }
            if (self.markPanel) {
                self.markPanel.playAdRewardAnim(info, callback)
            } else {
                if (callback) {
                    callback()
                }
            }
        } else {
            //  老版签到直接刷新界面
            // info.lastMarkRewards = table([0,evt.data.rewards])
            info.lastMarkRewards = evt.data.rewards
            var [coin, cash] = [0, 0]
            evt.data.rewards = evt.data.rewards || table()
            for (let i = 1, v = evt.data.rewards[1]; v; i++ , v = evt.data.rewards[i]) {
                if (v.itemId === GamePropIds.kCoin) {
                    coin = coin + v.num
                } else if (v.itemId === GamePropIds.kCash) {
                    cash = cash + v.num
                }
            }
            var HomeScene = require("clover/scene/HomeScene")
            var infoBanner = HomeScene.getInstance().infoBanner
            infoBanner.lockCoin(coin)
            infoBanner.lockCash(cash)

            panel.refresh(info, 1, function () {
                var meta = MetaManager.getInstance().getMarkByNum(info.markNum)
                if (meta.goodsId !== 0) {
                    //self:popMarkPrise(meta.goodsId, panel)
                }
                self.isBusy = false
            }, table([1, "coin", coin], [1, "cash", cash]))
        }
    }
    function onFail(evt) {
        self.isBusy = false
        Toast.make(getText("error.tip." + tostring(evt.data)))
    }
    function onCancel() {
        self.isBusy = false
    }
    let http = ClientConfigHttp.new(false)//配置信息同步
    http.load()
    if (ttUseDiamond && TTUtil.isOpenSmallPay()){
        // ad_session

        TTUtil.smallPay({
            session: ad_session,
            goodName:"签到",
            type: "mark"
        },()=>{
            UserMark.getInstance().mark(onSuccess, onFail, onCancel, { videoFlag: true, adFlag: false, cashFlag: false, videoAndMarkFlag: true})  
        },()=>{
            self.isBusy = false
        })
  
        return
    }

    var snsProxy = require("clover/sns/SnsProxy").getInstance()
    
    // //TODO:测试代码
    // UserMark.getInstance().mark(onSuccess, onFail, onCancel, { videoFlag: true, adFlag: false, cashFlag: false, videoAndMarkFlag: true})
    // return

    if (UserMark.getInstance().isNewMark()) {
        if (snsProxy.allowAd()) {
            snsProxy.prepareAd("MarkExtraReward")
            .then(()=>{
                //  播放广告
                SnsProxy.getInstance().showAd("MarkExtraReward")
                .then(isEnd=> {
                    if (isEnd) {
                        DCAssist.dc4AdFinish("mark", "mark_ad_finish", { "ad_src": "mark_panel", "type": "new" });
                        console.warn("onRewardedVideoAdClose finish")
                        UserMark.getInstance().mark(onSuccess, onFail, onCancel, { videoFlag: true, adFlag: false, cashFlag: false, videoAndMarkFlag: true})
                    } else {
                        self.isBusy = false
                        DCAssist.dc4AdDropOut("mark", "mark_ad_dropout", { "ad_src": "mark_panel", "type": "new" });
                        Toast.make(getText("error.tip.dropout_ad"));
                    }
                },(err)=>{
                    if (err && err.errMsg){
                        Toast.make(err.errMsg)
                    }else{
                        Toast.make(getText("video.ad.error"));
                    }
                    DCAssist.dc4AdNoMore("mark", "mark_noAds", { "ad_src": "mark_panel", "type": "new" });  
                    self.isBusy = false
                })
                .catch(err=> {
                    Toast.make(getText("video.ad.error"));
                    DCAssist.dc4AdNoMore("mark", "mark_noAds", { "ad_src": "mark_panel", "type": "new" });  
                    if (window.logCenter) {
                        let msg = {
                            message: "Mark onRewardedVideoAdError: " + JSON.stringify(err)
                        }
                        window.logCenter.log(msg)
                    } else {
                        cc.error("Mark onRewardedVideoAdError: " + err.errMsg)
                    }
                    self.isBusy = false
                })
            })
            .catch(err=> {
                self.isBusy = false
                console.error("MarkPanel prepare ad failed!", err);
                Toast.make(getText("video.ad.error"), null, function () {
                });
            })
        }else {
            Toast.make(getText("video.ad.error"))
            self.isBusy = false
        }
    } else {
        if (!snsProxy.isAdReady()) {        
            Toast.make(getText("video.ad.error"), null, function () {            
                panel.isChecked = false            
                // 改为没有视频时自动签到            
                UserMark.getInstance().mark(onSuccess, onFail, onCancel, { adMark: true, random: false })        
            });        
            return;    
        } 

        snsProxy.showAd("MarkExtraReward")    
        .then(isEnd=> {        
            if (isEnd) {            
                DCAssist.dc4AdFinish("mark", "mark_ad_finish", { "ad_src": "mark_panel", "type": "old" });
                console.warn("onRewardedVideoAdClose finish")            
                UserMark.getInstance().mark(onSuccess, onFail, onCancel, { adMark: true, random: true })        
            } else {            
                self.isBusy = false            
                DCAssist.dc4AdDropOut("mark", "mark_ad_dropout", { "ad_src": "mark_panel", "type": "old" });            
                Toast.make(getText("error.tip.dropout_ad"));        
            }    
        },(err)=>{
            if (err && err.errMsg){
                Toast.make(err.errMsg)
            }else{
                Toast.make(getText("video.ad.error"));
            }
            DCAssist.dc4AdNoMore("mark", "mark_noAds", { "ad_src": "mark_panel", "type": "old" });        
            panel.isChecked = false        
            // 改为没有视频时自动签到        
            UserMark.getInstance().mark(onSuccess, onFail, onCancel, { adMark: true, random: false })    
        })    
        .catch(err=> {        
            Toast.make(getText("video.ad.error"));        
            DCAssist.dc4AdNoMore("mark", "mark_noAds", { "ad_src": "mark_panel", "type": "old" });        
            if (window.logCenter) {            
                let msg = {                
                    message: "Mark onRewardedVideoAdError: " + JSON.stringify(err)            
                }            
                window.logCenter.log(msg)        
            } else {            
                cc.error("Mark onRewardedVideoAdError: " + err.errMsg)        
            }        
            panel.isChecked = false        
            // 改为没有视频时自动签到        
            UserMark.getInstance().mark(onSuccess, onFail, onCancel, { adMark: true, random: false })    
        })
    }
}

MarkLogic.prototype.remark = function (panel) {
    var self = this
    self.isRemark = true // 补签不弹出限时宝箱
    function onSuccess(evt) {
        var info = self.getFullInfo()
        var [coin, cash] = [0, 0]
        evt.data.rewards = evt.data.rewards || table()
        for (let i = 1, v = evt.data.rewards[1]; v; i++ , v = evt.data.rewards[i]) {
            if (v.itemId === GamePropIds.kCoin) {
                coin = coin + v.num
            } else if (v.itemId === GamePropIds.kCash) {
                cash = cash + v.num
            }
        }
        var HomeScene = require("clover/scene/HomeScene")
        var infoBanner = HomeScene.getInstance().infoBanner
        infoBanner.lockCoin(coin)
        infoBanner.lockCash(cash)
        panel.refresh(info, 1, function () {
            var meta = MetaManager.getInstance().getMarkByNum(info.markNum)
            if (meta.goodsId !== 0) {
                //self:popMarkPrise(meta.goodsId, panel)
            }
            self.isBusy = false
        }, table([1, "coin", coin], [1, "cash", cash]))
    }
    function onFail(evt) {
        if (evt.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            // var CashNotEnoughPanel = require("clover/panel/CashNotEnoughPanel")
            // var confirm = CashNotEnoughPanel.create(function () {
            //     require("clover/panel/MarketPanel")
            //     MarketPanel.show(MarketPanelTabId.kCashTab, function (market) {
            //         market.setCloseCallback(function () {
            //             self.isBusy = false
            //             market.clearCloseCallback()
            //         })
            //     })
            // }, function () {
            //     self.isBusy = false
            // })
            // confirm.popup(true)
            require("clover/panel/CashNotEnoughPanel").show(function (show_panel) {
                show_panel.on(BasePanelEvent.Close, ()=>{
                    if (!self.isClosed) {
                        self.refreshEnergyBottles()
                        self.updateItemNumber()
                    }
                })
                // require("clover/panel/MarketPanel")
                // MarketPanel.show(MarketPanelTabId.kCashTab, function (market) {
                //     market.setCloseCallback(function () {
                //         self.isBusy = false
                //         market.clearCloseCallback()
                //     }, function () {
                //         self.isBusy = false
                //     })
                // })
            }, function () {
                self.isBusy = false
            }, true)
        } else {
            self.isBusy = false
            Toast.make(getText("error.tip." + tostring(evt.data)))
        }
    }
    function onCancel() {
        self.isBusy = false
    }
    UserMark.getInstance().remark(onSuccess, onFail, onCancel)
}
/**
 * 新签到补签
 */
MarkLogic.prototype.newRemark = function (target, isVideoRemark) {
    var self = this
    function onSuccess(evt) {
        var info = self.getFullInfo()
        //  领奖
        self.isBusy = false
        if (evt.data.sevenDaysRewards && $len(evt.data.sevenDaysRewards) > 0) {
            //  七天签到奖励
            self.markPanel.refreshRemarkWithAnim(info, target, true)
        } else {
            self.markPanel.refreshRemarkWithAnim(info, target, false)
        }
    }
    function onFail(evt) {
        if (evt.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            require("clover/panel/CashNotEnoughPanel").show(function (show_panel) {
                show_panel.on(BasePanelEvent.Close, ()=>{
                    self.isBusy = false
                })
                
                // require("clover/panel/MarketPanel")
                // MarketPanel.show(MarketPanelTabId.kCashTab, function (market) {
                //     market.setCloseCallback(function () {
                //         self.isBusy = false
                //         market.clearCloseCallback()
                //     }, function () {
                //         self.isBusy = false
                //     })
                // })
            }, function () {
                self.isBusy = false
            }, true)
        } else {
            self.isBusy = false
            if (evt.data){
                Toast.make(getText("error.tip." + tostring(evt.data)))
            }
        }
    }
    function onCancel() {
        self.isBusy = false
    }
    UserMark.getInstance().newRemark(onSuccess, onFail, onCancel, target, isVideoRemark)
}
MarkLogic.prototype.popMarkPriseWxChest = function (target, panel, countdown, data) {
    var self = this
    var [rewards, startTime, endTime] = MarkPriseWxChestLogic.prototype.getMarkPrise()
    MarkPriseWxChestLogic.prototype.addMarkPrise(target, null, countdown)
    var button = MarkPriseWxChestLogic.prototype.createButton()
    var p00, p11
    if (button) {
        button.setVisible(false)
        if (!self.priseButton || !self.priseButton.nodeExist) {
            self.priseButton = MarkPriseWxChestButton.create(button.getEndTime(), button.getClicked())
            self.priseButton.setPosition(cc.p(button.getPosition()))
            self.priseButton.on(MarkPriseWxChestButtonEvent.TimeUp, function () {
                self.priseButton.removeFromParent(true)
            })
            let parent = panel.getParent()
            parent && parent.addChild(self.priseButton)
            MarkPriseWxChestLogic.prototype.delegateButton(self.priseButton)
        } else {
            self.priseButton.setEndTime(button.getEndTime())
            self.priseButton.setClicked(button.getClicked())
        }
        [p00, p11] = self.priseButton.getAnglePosition()
    }
    MarkPriseWxChestLogic.create().start(function () {
        var [gid, st, et] = MarkPriseWxChestLogic.prototype.getMarkPrise()
        if (gid == null) {
            MarkPriseWxChestLogic.prototype.addMarkPrise(rewards, startTime, endTime)
        }
        self.isBusy = false
    }, null, table([1, "p00", p00], [1, "p11", p11]), data)
}
MarkLogic.prototype.popMarkPrise = function (target, panel) {
    var self = this
    var [goodsId, startTime] = MarkPriseLogic.prototype.getMarkPrise()
    MarkPriseLogic.prototype.addMarkPrise(target)
    var button = MarkPriseLogic.prototype.createButton()
    var p00, p11
    if (button) {
        button.setVisible(false)
        if (!self.priseButton || !self.priseButton.nodeExist) {
            self.priseButton = MarkPriseButton.create(button.getEndTime())
            self.priseButton.setPosition(cc.p(button.getPosition()))
            self.priseButton.on(MarkPriseButtonEvent.TimeUp, function () {
                self.priseButton.removeFromParent(true)
            })
            panel.getParent().addChild(self.priseButton)
            MarkPriseLogic.prototype.delegateButton(self.priseButton)
        } else {
            self.priseButton.setEndTime(button.getEndTime())
        }
        [p00, p11] = self.priseButton.getAnglePosition()
    }
    MarkPriseLogic.create().start(function () {
        var [gid, st] = MarkPriseLogic.prototype.getMarkPrise()
        if (gid === 0) {
            MarkPriseLogic.prototype.addMarkPrise(goodsId, startTime)
        }
        self.isBusy = false
    }, null, table([1, "p00", p00], [1, "p11", p11]))
}
var dayTime = 3600000 * 24
var pkTimeOffset = 3600000 * 8
MarkLogic.prototype.getFullInfo = function () {
    var self = this

    var data = UserMark.getInstance().getMarkInfo()
    var cycleDayNum = data.cycleTime / dayTime
    var now = Localhost.time()
    if (UserMark.getInstance().isNewMark()) {
        data.markRef = MetaManager.getInstance().getNewMarkConfig()
        now = now - (now + pkTimeOffset) % dayTime
        var startTime = data.cycleStartTime - (data.cycleStartTime + pkTimeOffset) % dayTime
        data.remainDayNum = cycleDayNum - Math.ceil((now - startTime) / dayTime)
        data.price = data.markRef.remark_cost[data.remarkNum]
    } else {
        data.remainDayNum = cycleDayNum - Math.ceil((now - data.cycleStartTime) / dayTime) + 1
        data.markRef = MetaManager.getInstance().getMarkConfig()
        var meta = MetaManager.getInstance().getGoodsMeta(data.remarkGoodsId)
        data.price = meta.qCash
    }
    data.goodsIcon = GamePropIds.kCash
    return data
}

module.exports = MarkLogic
